import { FC } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmationDialogContent } from './confirmationDialogContent/ConfirmationDialogContent'
import { IConfirmationDialogContentProps } from './models/IConfirmationDialogProps'

import styles from './ConfirmationDialog.module.scss'

export interface IConfirmationDialogProps extends IConfirmationDialogContentProps {
  isVisible: boolean
  size?: 'auto' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export const ConfirmationDialog: FC<IConfirmationDialogProps> = ({
  isVisible,
  size = 'sm',
  ...props
}: IConfirmationDialogProps) => {
  return (
    <ModalDialog
      classes={{ window: styles.window }}
      content={ConfirmationDialogContent}
      onClose={() => undefined}
      contentProps={props}
      show={isVisible}
      size={size}
      closeOnOutsideClick={false}
    />
  )
}
